import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@chakra-ui/react3'

/**
 * Displays CMS text with support for inline formatting tags.
 * Automatically converts supported custom tags (e.g. <product>…</product>)
 * into styled inline elements and applies the expected styling via global CSS.
 *
 * @component
 * @param {node} props.children - CMS text that may contain inline markup.
 * @returns {JSX.Element|null}
 */

const RichText = ({children, css: cssProp, ...rest}) => {
    if (!children) return null

    // to replace with <span> is better for a11y, otherwise not all screen readers can read unknown tags properly
    const html = children
        .replace(/<product>/g, '<span  class="product">')
        .replace(/<\/product>/g, '</span>')

    return (
        <Text
            dangerouslySetInnerHTML={{__html: html}}
            css={[
                cssProp,
                {
                    '& .product': {
                        fontStyle: 'italic',
                        // due to the italics, if tag with product stands before some other word,
                        // the space between them is visually hidden, that's why marginInlineEnd: '0.2rem'
                        marginInlineEnd: '0.2rem'
                    }
                }
            ]}
            {...rest}
        />
    )
}

RichText.propTypes = {
    children: PropTypes.node,
    css: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default RichText
